module.exports = __webpack_public_path__ + "media/images/logo-8151677885bef9776365e8176f00b512.png";